module.exports = __webpack_public_path__ + "static/media/lepes9.8348e4fd.png";